
export default {
  data() {
    return {
      props: [
        {
          name: 'locale',
          type: ['enum'],
          default: { value: 'de', type: 'string' },
          description: this.$t('locale'),
          options: ['en', 'de'],
        },
        {
          name: 'financial-type',
          type: ['enum'],
          default: { value: 'purchase', type: 'string' },
          description: this.$t('financial-type'),
          options: ['purchase', 'refinancing'],
        },
        {
          name: 'property-price',
          type: ['number', 'string'],
          default: { value: '400000', type: 'number' },
          description: this.$t('property-price'),
        },
        {
          name: 'down-payment',
          type: ['number', 'string'],
          default: { value: '60000', type: 'number' },
          description: this.$t('down-payment'),
        },
        {
          name: 'commission',
          type: ['number', 'string'],
          default: { value: '0.00', type: 'number' },
          description: this.$t('commission'),
        },
        {
          name: 'property-value',
          type: ['number', 'string'],
          default: { value: '400000', type: 'number' },
          description: this.$t('property-value'),
        },
        {
          name: 'remaining-loan-amount',
          type: ['number', 'string'],
          default: { value: '40000', type: 'number' },
          description: this.$t('remaining-loan-amount'),
        },
        {
          name: 'payout-date',
          type: ['string'],
          default: { value: 'undefined', type: 'keyword' },
          description: this.$t('payout-date'),
        },
        {
          name: 'repayment',
          type: ['number', 'string'],
          default: { value: 'undefined', type: 'keyword' },
          description: this.$t('repayment'),
        },
        {
          name: 'postcode',
          type: ['number', 'string'],
          default: { value: 'undefined', type: 'keyword' },
          description: this.$t('postcode'),
        },
        {
          name: 'tracking-id',
          type: ['string'],
          default: { value: 'undefined', type: 'keyword' },
          description: this.$t('tracking-id'),
        },
        {
          name: 'skip-calculation',
          type: ['boolean'],
          default: { value: 'false', type: 'boolean' },
          description: this.$t('skip-calculation'),
        },
        {
          name: 'testing',
          type: ['boolean'],
          default: { value: 'false', type: 'boolean' },
          description: this.$t('testing'),
        },
      ],
    };
  },
};
